module.exports = __webpack_public_path__ + "static/media/31 50-50.ab6143bd.jpg";